
import {
  GetCustomResourceQueryMsg,
  GetCustomResourceQueryQuery
} from "../autogenerated/ZoomBridge";
import ErrorHandler from "../error/ErrorHandler";

export default class GetCustomPropsQuery {
  run() {
    return new Promise((onSuccess, onFailure) => {
      this.onSuccess = onSuccess;
      this.onFailure = onFailure;
      this.executeQuery(onSuccess, onFailure);
    });
  }

  executeQuery() {
    const query = new GetCustomResourceQueryQuery();
    query.message = new GetCustomResourceQueryMsg();
    query.noAuth = true;
    query.run().then(
      (resp) => {
        this.onSuccess(resp);
      },
      (failedResp) => {
        setTimeout(() => {
          ErrorHandler.handleError(failedResp, null, false, false, () => {
            this.executeQuery();
          });
        }, !window.setError ? 100 : 0);
        //onFailure(failedResp);
      }
    );
  }

}